module.exports = __webpack_public_path__ + "static/img/brand-value-3.bddb366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/brand-value-3.png
// module id = Hc8q
// module chunks = 1